import {getAnalysisPoolDataCount } from '../io/api.js'//应用mutation
export const setUser = ({commit},user) => {
  commit("userStatus",user)
}
// //获取用户头像
// export const setImage = ({commit},imageUrl) => {
//   commit("userImageGet",imageUrl)
// }
export const setToken = ({commit},userToken) => {
  commit("userToken",userToken)
}
export default {
	// 医案库列表
	getStore_list({state,commit},params){
        // getStoreList(params).then(res=>{
        //     let data = res.data;
        //     if (data && data.code == 0) {
        //         commit('setMedicalList',data.data)
        //         commit('setMedicalLoading',false)
        //     }else{
		// 		commit('setMedicalLoading',false)
        //         commit('setToast',{type:'error',info:data.msg||'保存成功'})
        //     }
        // })
    },
    //分析池数量
    getAnalysisNum({state,commit},params){
        getAnalysisPoolDataCount().then(res=>{
            let {data,code,msg}=res.data;
            if(code==0){ 
                commit('setAnalysisNum',data.count)
            }else{
                this.$message.error(msg||'查询分析池数量失败～')
            }
        })
    },
}